"use client";

import Carousel from "./components/carousel";
import DrivenPurpose from "./components/drivenpurpose";
import EbaRetailSection from "./components/eba-retail";
import Feature from "./components/feature";
import GrowPurpose from "./components/growpurpose";
import Insight from "./components/insight";
import Partners from "./components/partners";
import Report from "./components/report";
import Services from "./components/services";
import HomepagePopup from "./components/HomepagePopup";
import { useHomePage } from "./hooks/useHomePage";

export default function Homepage() {
  const { data, isLoading, isError } = useHomePage();

  return (
    <main className="flex flex-col gap-[60px] md:gap-[100px] mb-[60px] md:mb-[100px] [&_p]:text-[18px]">
      <HomepagePopup />
      <Carousel />
      <DrivenPurpose data={data} isLoading={isLoading} isError={isError} />
      <Services data={data} />
      <Insight data={data} />
      <EbaRetailSection data={data} />
      <GrowPurpose data={data} />
      <Report data={data} />
      <Feature data={data} />
      <Partners data={data} />
    </main>
  );
}
